var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "printer",
    clipPath: "url(#clip0_2971_28126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.9997 4.66683V3.46683C11.9997 2.72009 11.9997 2.34672 11.8544 2.06151C11.7265 1.81063 11.5225 1.60665 11.2717 1.47882C10.9864 1.3335 10.6131 1.3335 9.86634 1.3335H6.13301C5.38627 1.3335 5.0129 1.3335 4.72769 1.47882C4.4768 1.60665 4.27283 1.81063 4.145 2.06151C3.99967 2.34672 3.99967 2.72009 3.99967 3.46683V4.66683M3.99967 12.0002C3.37969 12.0002 3.0697 12.0002 2.81537 11.932C2.12519 11.7471 1.58609 11.208 1.40116 10.5178C1.33301 10.2635 1.33301 9.95348 1.33301 9.3335V7.86683C1.33301 6.74672 1.33301 6.18667 1.55099 5.75885C1.74274 5.38252 2.0487 5.07656 2.42503 4.88482C2.85285 4.66683 3.4129 4.66683 4.53301 4.66683H11.4663C12.5864 4.66683 13.1465 4.66683 13.5743 4.88482C13.9506 5.07656 14.2566 5.38252 14.4484 5.75885C14.6663 6.18667 14.6663 6.74672 14.6663 7.86683V9.3335C14.6663 9.95348 14.6663 10.2635 14.5982 10.5178C14.4133 11.208 13.8742 11.7471 13.184 11.932C12.9296 12.0002 12.6197 12.0002 11.9997 12.0002M9.99967 7.00016H11.9997M6.13301 14.6668H9.86634C10.6131 14.6668 10.9864 14.6668 11.2717 14.5215C11.5225 14.3937 11.7265 14.1897 11.8544 13.9388C11.9997 13.6536 11.9997 13.2802 11.9997 12.5335V11.4668C11.9997 10.7201 11.9997 10.3467 11.8544 10.0615C11.7265 9.81063 11.5225 9.60665 11.2717 9.47882C10.9864 9.3335 10.6131 9.3335 9.86634 9.3335H6.13301C5.38627 9.3335 5.0129 9.3335 4.72769 9.47882C4.4768 9.60665 4.27283 9.81063 4.145 10.0615C3.99967 10.3467 3.99967 10.7201 3.99967 11.4668V12.5335C3.99967 13.2802 3.99967 13.6536 4.145 13.9388C4.27283 14.1897 4.4768 14.3937 4.72769 14.5215C5.0129 14.6668 5.38627 14.6668 6.13301 14.6668Z",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2971_28126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.54d3481112d3624dedcc47360af85125.svg";
export { ForwardRef as ReactComponent };